<form [formGroup]="form" class="flex flex-col min-h-0" (ngSubmit)="onSubmit()">
	<div>
		<app-input
			type="cents"
			label="Purchase Price (Title Insurance only)"
			formControlName="purchasePriceOverrideTitleInsurance"
			[placeholder]="placeholder | centsToDollars"
			[startIcon]="ICON.DOLLAR"
		></app-input>
	</div>
	<hr class="mt-6 -ml-[1.5rem] -mr-[1.5rem]" />
	<div class="flex justify-end mt-6 gap-2">
		<ui-button
			color="gray"
			label="Cancel"
			(click)="close()"
			[disabled]="submitted_()"
		></ui-button>
		<ui-button
			preset="HIGH_EMPHASIS"
			type="submit"
			label="Save"
			[disabled]="submitted_()"
			[loading]="submitted_()"
		></ui-button>
	</div>
</form>
